import React from 'react';
import noop from 'lodash/noop';
export const PopperDropdownContext = /*#__PURE__*/ React.createContext({
    setToggleRef: noop,
    toggleElement: null
});
PopperDropdownContext.displayName = 'PopperDropdownContext';
